import { render } from "./PriceListCompareDialog.vue?vue&type=template&id=05750f0a&scoped=true"
import script from "./PriceListCompareDialog.vue?vue&type=script&lang=js"
export * from "./PriceListCompareDialog.vue?vue&type=script&lang=js"

import "./PriceListCompareDialog.vue?vue&type=style&index=0&id=05750f0a&scoped=true&lang=css"
import "./PriceListCompareDialog.vue?vue&type=style&index=1&id=05750f0a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05750f0a"]])

export default __exports__